import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addSupplier } from "../Redux/Actions/SupplierActions";
import "./SupplierForm.css";

const SupplierForm = () => {
  const [companyName, setCompanyName] = useState("");
  const [matriculeF, setMatriculeF] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [iban, setIban] = useState("");
  const [bankName, setBankName] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactRole, setContactRole] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("");
  const [category, setCategory] = useState("");
  const [notes, setNotes] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const supplierData = {
      companyName,
      matriculeF,
      address,
      phone,
      email,
      website,
      iban,
      bankName,
      contactName,
      contactRole,
      contactPhone,
      contactEmail,
      paymentTerms,
      category,
      notes,
    };
    dispatch(addSupplier(supplierData, navigate));
  };

  return (
    <div className="container">
      <Form onSubmit={handleSubmit}>
        <h2>Enregistrer un fournisseur</h2>

        {/* Partie 1: Informations sur l'entreprise */}
        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Nom de l'entreprise</Form.Label>
            <Form.Control
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Matricule Fiscal</Form.Label>
            <Form.Control
              type="text"
              value={matriculeF}
              onChange={(e) => setMatriculeF(e.target.value)}
            />
          </Form.Group>
        </div>

        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Adresse</Form.Label>
            <Form.Control
              as="textarea"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Téléphone</Form.Label>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Form.Group>
        </div>

        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Site web</Form.Label>
            <Form.Control
              type="text"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </Form.Group>
        </div>

        {/* Informations bancaires */}
        <h3>Informations bancaires</h3>
        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>IBAN</Form.Label>
            <Form.Control
              type="text"
              value={iban}
              onChange={(e) => setIban(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Nom de la banque</Form.Label>
            <Form.Control
              type="text"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
            />
          </Form.Group>
        </div>

        {/* Personne de contact */}
        <h3>Personne de contact</h3>
        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Nom et prénom</Form.Label>
            <Form.Control
              type="text"
              value={contactName}
              onChange={(e) => setContactName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Fonction</Form.Label>
            <Form.Control
              type="text"
              value={contactRole}
              onChange={(e) => setContactRole(e.target.value)}
            />
          </Form.Group>
        </div>

        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Téléphone</Form.Label>
            <Form.Control
              type="tel"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
            />
          </Form.Group>
        </div>

        {/* Autres informations */}
        <h3>Autres informations</h3>
        <div className="row">
          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Conditions de paiement</Form.Label>
            <Form.Control
              type="text"
              value={paymentTerms}
              onChange={(e) => setPaymentTerms(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3 col-md-6">
            <Form.Label>Catégorie</Form.Label>
            <Form.Control
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            />
          </Form.Group>
        </div>

        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Form>
    </div>
  );
};

export default SupplierForm;
